var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.ClientInformation', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        $stateProvider
            .state('clientInformation', {
            url: '/clientInformation',
            templateUrl: qmcBase + '/ClientInformation',
            controller: 'ClientInformationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: ClientInformation');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        ClientInformation.HttpProvider = HttpProvider;
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.ClientInformation')
        .config(['$httpProvider', QMC.ClientInformation.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        let ClientInformationService = class ClientInformationService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/ClientInformation';
            }
            getClientInformationWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            getCategoryList() {
                return super.getItem(this.modulePath + '/CategoryList', {}, (data) => {
                    return data;
                });
            }
            getClientInformation(form, formatText = false) {
                return super.post(this.modulePath + `?formatText=${formatText}`, form).then((data) => {
                    return data;
                });
            }
        };
        ClientInformationService = __decorate([
            QMC.Service('QMC.ClientInformation', 'ClientInformationService'),
            QMC.Inject('$http', '$q')
        ], ClientInformationService);
        ClientInformation.ClientInformationService = ClientInformationService;
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        let QmClientInformationDirective = class QmClientInformationDirective {
            constructor($qui, lng, permissionService, clientInformationService, clientService, employeeService) {
                this.$qui = $qui;
                this.lng = lng;
                this.permissionService = permissionService;
                this.clientInformationService = clientInformationService;
                this.clientService = clientService;
                this.employeeService = employeeService;
                this.restrict = 'E';
                this.templateUrl = './clientinformation/ClientInformationDirective';
                this.replace = true;
                this.scope = {
                    qmSelectedClients: '=',
                };
                this.groupTags = {
                    client: this.lng.translate(0, 'Klient'),
                    flsGroup: this.lng.translate(0, 'Fachleistungsgruppe'),
                    personslist: this.lng.translate(0, 'Personenliste')
                };
                this.link = (scope) => {
                    const storageName = 'ClientInfo_' + $('#session').data().userId;
                    scope.form = {
                        clients: scope.qmSelectedClients,
                        employee: scope.qmSelectedEmployee,
                        includeEmployeesThatModified: true,
                        markings: [],
                        livingAreas: [],
                        dateFrom: new Date().setMonth(new Date().getMonth() - 1),
                        dateTo: new Date(),
                        categoryPreselection: "a6ce4251-f69e-4f03-b7c0-00d80e53aeaf",
                        searchwords: "",
                        privateContent: false,
                        allCategories: true,
                        allLivingAreas: true
                    };
                    scope.clientInfo = {
                        clientInformation: [],
                        clientInfoText: "",
                        orderAsc: false
                    };
                    const cacheFilter = () => {
                        const temp = angular.copy(scope.form);
                        delete temp.clients;
                        delete temp.employee;
                        delete temp.dateFrom;
                        delete temp.dateTo;
                        temp.orderAsc = scope.clientInfo.orderAsc;
                    };
                    scope.$watch('qmSelectedEmployee', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        scope.form.clients = scope.qmSelectedEmployee;
                    });
                    scope.$watch('qmSelectedClients', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        scope.form.clients = scope.qmSelectedClients;
                    });
                    scope.$watch('form.clients', (newVal, oldVal) => {
                        if (newVal === oldVal)
                            return;
                        scope.qmSelectedClients = scope.form.clients;
                    });
                    this.permissionService.getPermissionsByObjectType(143000).then((data) => {
                        scope.permissions = data[0];
                    });
                    scope.init = () => {
                        let restoreStorage = false;
                        scope.$watch('clientInfo.orderAsc', (newVal, oldVal) => {
                            if (newVal === oldVal)
                                return;
                            cacheFilter();
                            scope.clientInfo.clientInfoText = this.createTextFromClientInfo(scope.clientInfo.clientInformation, scope.clientInfo.orderAsc);
                        });
                        scope.$watch('form.categoryPreselection', (newVal, oldVal) => {
                            if (restoreStorage)
                                return;
                            if (newVal !== oldVal || !scope.form || !scope.form.categoryPreselection)
                                // find selected preselection
                                for (const category of scope.categoryPreselectionList) {
                                    if (category.id === scope.form.categoryPreselection) {
                                        scope.form.categories = category.category;
                                        scope.form.livingAreas = category.livingArea.filter(x => x != null);
                                        break;
                                    }
                                }
                            //if no livingAreas where found for the selected category, fill the livingAreas with the formattedLivingAreas
                            if (scope.form.livingAreas.length === 0) {
                                scope.form.livingAreas = scope.formattedLivingAreas.map(a => a.value);
                            }
                        });
                        if (QMC.Common.personalLocalStorage.getItem(storageName)) {
                            restoreStorage = true;
                            const storage = JSON.parse(QMC.Common.personalLocalStorage.getItem(storageName));
                            scope.clientInfo.orderAsc = storage.orderAsc;
                            scope.form = { ...scope.form, ...storage };
                            setTimeout(() => { restoreStorage = false; }, 50);
                        }
                        scope.$watch('form', () => {
                            cacheFilter();
                        }, true);
                    };
                    scope.getData = () => {
                        scope.loadingData = true;
                        this.clientInformationService.getCategoryList().then((dataCategoryList) => {
                            scope.categoryPreselectionList = dataCategoryList;
                            scope.formattedCategoryPreselections = dataCategoryList.map(x => ({ value: x.id, text: x.name }));
                            this.clientInformationService.getClientInformationWv().then((dataWv) => {
                                scope.loadingData = false;
                                dataWv.livingAreaWvList.unshift({
                                    id: QMC.Common.Constants.GUID_EMPTY,
                                    objectId: QMC.Common.Constants.GUID_EMPTY,
                                    name: this.lng.translate(20026009, "Ohne Lebensbereich"),
                                    isFix: true,
                                    value: 0
                                });
                                scope.formattedCategories = dataWv.categoryWvList.map(x => ({ value: x.objectId, text: x.name }));
                                scope.formattedLivingAreas = dataWv.livingAreaWvList.map(x => ({ value: x.objectId, text: x.name }));
                                scope.formattedMarkings = dataWv.markingWvList.map(x => ({ value: x.objectId, text: x.name }));
                                this.clientInformationService.getCategoryList().then((dataCategoryList) => {
                                    scope.categoryList = dataCategoryList;
                                    for (const category of scope.categoryList) {
                                        if (category.category.length === 0)
                                            category.category = scope.formattedCategories.map(a => a.value);
                                        if (category.livingArea.length === 0)
                                            category.livingArea = scope.formattedLivingAreas.map(a => a.value);
                                    }
                                    scope.init();
                                });
                            });
                        });
                    };
                    scope.getReferences = () => {
                        scope.formattedReferences = [];
                        scope.loadingClients = true;
                        this.clientService.getClientPersonList().then((data) => {
                            scope.formattedReferences = scope.formattedReferences.concat(data.map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.lastName, x.firstName, x.shortCaption, x.personNumber) + `, ${x.institute}`, group: this.groupTags.client })));
                            scope.loadingClients = false;
                        });
                        this.clientService.getFlsGroupList(0, -1).then((data) => {
                            scope.formattedReferences = scope.formattedReferences.concat(data.items.map(x => ({ value: x.objectId, text: x.name + `, ${x.institution}`, group: this.groupTags.flsGroup })));
                        });
                        this.clientService.getAllPersonLists().then((data) => {
                            scope.formattedReferences = scope.formattedReferences.concat(data.map(x => ({ value: x.objectId, text: x.name, group: this.groupTags.personslist })));
                        });
                    };
                    scope.getEmployee = () => {
                        scope.loadingEmployee = true;
                        this.employeeService.getEmployeeList().then((data) => {
                            scope.formattedEmployee = data.map((x) => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.employeeNr), group: x.institute }));
                            scope.loadingEmployee = false;
                        });
                    };
                    scope.getData();
                    scope.getReferences();
                    scope.getEmployee();
                    scope.print = () => {
                        const winPrint = window.open('', '', 'left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0');
                        winPrint.document.write(scope.clientInfo.clientInfoText);
                        winPrint.document.close();
                        winPrint.focus();
                        winPrint.print();
                        winPrint.close();
                    };
                    scope.createClientInfo = () => {
                        var _a, _b;
                        scope.clientInfo.clientInformation = [];
                        scope.clientInfo.clientInfoText = '';
                        if (scope.form.clients.length === 0) {
                            this.$qui.notify({
                                message: this.lng.translate(20026007, "Kein Klient angegeben"),
                                title: this.lng.translate(20002017, "Warnung"),
                                timer: 5000
                            });
                            return;
                        }
                        scope.form.dateFrom = this.$qui.createDateFromString(scope.form.dateFrom);
                        scope.form.dateTo = this.$qui.createDateFromString(scope.form.dateTo);
                        scope.loadingInfo = true;
                        const getForm = {
                            references: this.createReferences((_a = scope.form.clients) !== null && _a !== void 0 ? _a : [], (_b = scope.form.employee) !== null && _b !== void 0 ? _b : [], scope.formattedReferences),
                            //ReferenceClientIds: scope.form.clients,
                            //ReferenceEmployeeIds: scope.form.employee,
                            includeEmployeesThatModified: scope.form.includeEmployeesThatModified,
                            categoryIds: scope.form.categories,
                            livingAreaIds: scope.form.livingAreas,
                            markingIds: scope.form.markings,
                            searchterms: scope.form.searchwords.split(";"),
                            dateFrom: scope.form.dateFrom,
                            dateTo: scope.form.dateTo,
                            privateContent: scope.form.privateContent
                        };
                        this.clientInformationService.getClientInformation(getForm, scope.form.formatText).then((data) => {
                            scope.clientInfo.clientInformation = data.sort((a, b) => a.reference.localeCompare(b.reference));
                            scope.clientInfo.clientInfoText = this.createTextFromClientInfo(scope.clientInfo.clientInformation, scope.clientInfo.orderAsc);
                            scope.loadingInfo = false;
                        });
                    };
                };
            }
            createTextFromClientInfo(clientInfo, orderAsc) {
                let result = "";
                // items are arrangend for client so we create text for client
                for (let i = 0; i < clientInfo.length; i++) {
                    const client = clientInfo[i];
                    if (i !== 0)
                        result += "<hr /><hr />";
                    // create Header
                    result += this.createBoldText(this.lng.translate(20026008, "Klienteninformation") + ": " + client.reference + " " + this.lng.translate(20000218, "vom") + " " + new Date().toLocaleDateString());
                    result += "<br>";
                    //Order list by datefrom according to setting
                    client.items = this.orderByDate(client.items, orderAsc);
                    for (const item of client.items) {
                        result += "<hr /><p>";
                        result += this.createBoldText(item.category + " " + client.reference + ', ' + item.title + "<br />");
                        if (item.dateFrom)
                            result += moment(item.dateFrom).format("DD.MM.YYYY HH:mm") + " ";
                        if (item.dateTo)
                            result += `- ${moment(item.dateTo).format("DD.MM.YYYY HH:mm")} `;
                        if (item.author && item.author.length > 0)
                            result += `${this.lng.translate(20000062, "Autor")}: ${item.author}`;
                        for (let k = 0; k < item.content.length; k++) {
                            const content = item.content[k];
                            result += "<br />";
                            let header = item.content[k].title && item.content[k].title.length > 0 ? this.createBoldText(item.content[k].title) + ' ' : '';
                            if (content.date && k > 0)
                                header += moment(content.date).format("DD.MM.YYYY HH:mm");
                            if (content.author && content.author.trim() !== "" && k > 0)
                                header += ` ${this.lng.translate(20000062, "Autor")}: ${content.author} `;
                            if (content.livingArea && content.livingArea.trim() !== "")
                                header += this.createBoldText(this.lng.translate(20000074, "Lebensbereich") + ": " + content.livingArea);
                            result += header.trim().length > 0 ? header.trim() + '<br />' : '';
                            result += content.comment.length > 0 ? `${content.comment}<br />` : "";
                        }
                        result += "</p>";
                    }
                    result += "<br />";
                }
                return result;
            }
            orderByDate(items, ascending) {
                return items.sort((a, b) => {
                    const aDateFrom = a.dateFrom ? this.$qui.createDateFromString(a.dateFrom) : undefined;
                    const bDateFrom = b.dateFrom ? this.$qui.createDateFromString(b.dateFrom) : undefined;
                    if ((!aDateFrom && bDateFrom) || (aDateFrom < bDateFrom))
                        return ascending ? -1 : 1;
                    if ((aDateFrom && !bDateFrom) || (aDateFrom > bDateFrom))
                        return ascending ? 1 : -1;
                    return 0;
                });
            }
            createBoldText(text) {
                return `<strong>${text}</strong>`;
            }
            createReferences(selectedReferences, selectedEmployees, references) {
                return [
                    ...selectedReferences.map(x => {
                        var _a;
                        return ({
                            id: x,
                            type: this.getReferenceTypeByGroupName((_a = references.filter(y => y.value === x)[0]) === null || _a === void 0 ? void 0 : _a.group)
                        });
                    }),
                    ...selectedEmployees.map(x => ({ id: x, type: 120000 }))
                ];
            }
            getReferenceTypeByGroupName(group) {
                switch (group) {
                    case this.groupTags.flsGroup:
                        return 710000;
                    case this.groupTags.personslist:
                        return 190000;
                    default:
                        return 140000;
                }
            }
        };
        QmClientInformationDirective = __decorate([
            QMC.Directive('QMC.ClientInformation', 'qmClientInformation', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'ClientInformationService', 'KlientService', 'EmployeeService'])
        ], QmClientInformationDirective);
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var ClientInformation;
    (function (ClientInformation) {
        let ClientInformationController = class ClientInformationController {
            /**
             * Creates an instance of ClientInformationController.
             * @param {ng.ILocationService} $location
             * @param {any} $qui
             * @param {any} $state
             *
             * @memberof ClientInfoController
             */
            constructor($location, $qui, $state) {
                this.$location = $location;
                this.$qui = $qui;
                this.$state = $state;
                this.selectedClients = [];
                this.$qui.init(this.$qui.getSectionColor("/clientInformation"), () => {
                    this.$qui.anonAvatar();
                    this.$qui.bindEvents();
                    this.$qui.navToggle();
                });
                if (document.getElementById("permissions").getAttribute("clientinformation").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module ClientInformation");
                    this.forbidden = true;
                    return;
                }
                if (this.$state.current.name === "clientInformationById") {
                    this.selectedClients.push(this.$state.params.id);
                }
            }
        };
        ClientInformationController = __decorate([
            QMC.Controller('QMC.ClientInformation', 'ClientInformationController'),
            QMC.Inject('$location', '$qui', '$state')
        ], ClientInformationController);
    })(ClientInformation = QMC.ClientInformation || (QMC.ClientInformation = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/ClientInformation/qmc.client-information.js.map
